import { BodyM } from '@casavo/base-ui'
import { ReactElement } from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { theme } from '@/design-lib/style-theme/theme.css'

import { listingDetailSection } from './style.css'

type Props = {
  children: React.ReactNode
  hasBorder?: boolean
  marginTop?: number
  title: string
  wide: boolean
}

export const ListingDetailSection = ({ children, hasBorder, title, wide }: Props): ReactElement => {
  return (
    <div className={listingDetailSection({ hasBorder, wide })}>
      {title && (
        <BodyM
          className={sprinkles({
            marginBottom: 'm',
            textTransform: 'uppercase',
          })}
        >
          {title}
        </BodyM>
      )}
      <div style={{ textAlign: 'justify' }}>{children}</div>
    </div>
  )
}
